export default __webpack_public_path__ + "static/media/ProfileBackground.4dc796b0.png";